'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noImagePanel = require('../../../molecules/no-image-panel');

var _noImagePanel2 = _interopRequireDefault(_noImagePanel);

var _imagePanel = require('../../../molecules/image-panel');

var _imagePanel2 = _interopRequireDefault(_imagePanel);

var _iconPanel = require('../../../molecules/icon-panel');

var _iconPanel2 = _interopRequireDefault(_iconPanel);

var _dataPointPanel = require('../../../molecules/data-point-panel');

var _dataPointPanel2 = _interopRequireDefault(_dataPointPanel);

var _linkPanel = require('../../../molecules/link-panel');

var _linkPanel2 = _interopRequireDefault(_linkPanel);

var _videoPanel = require('../../../molecules/video-panel');

var _videoPanel2 = _interopRequireDefault(_videoPanel);

var _socialInnovationPanel = require('../../../molecules/social-innovation-panel');

var _socialInnovationPanel2 = _interopRequireDefault(_socialInnovationPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  NoImagePanel: _noImagePanel2.default,
  ImagePanel: _imagePanel2.default,
  IconPanel: _iconPanel2.default,
  DataPointPanel: _dataPointPanel2.default,
  LinkPanel: _linkPanel2.default,
  VideoPanel: _videoPanel2.default,
  SocialInnovationPanel: _socialInnovationPanel2.default
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/panels/utilities/moleculesMap.js
// module id = 501
// module chunks = 4